export class OficinaFacturacion  {
  id: number = 0;
  descripcion: string = '';
  oficinaCode: string = '';
  nombreCompaniaNAV: string = '';
  numSerieFactNAV: string = '';
  navBaseUrl: string = '';
  createdBy: string;
  updatedBy: string;
  updatedDate: string;
  createdDate: string;
  createdByName: string;
  updatedByName: string;
  activo: boolean = true;
}
